/**
 * is true if the user has the required claim
 * @param {string[]} userClaims
 * @param {string} requiredClaim
 * @returns {boolean}
 */
export const hasClaim = (userClaims: string[] | undefined, requiredClaim: string): boolean => {
	if (!userClaims) {
		return false
	}
	return userClaims.includes(requiredClaim)
}

const moduleToMainModule = (claim : string) :string => {
	return claim.substring(0,4) + '000-000'
}

const moduleToSubModule = (claim: string) :string => {
	return claim.substring(0, 8) + '000'
}

export const hasRequiredClaim = (userClaims: string[] | undefined, requiredClaim: string): boolean => {
	if (!userClaims) {
		return false
	}

	const mainModule = moduleToMainModule(requiredClaim)
	const subModule = moduleToSubModule(requiredClaim)

	return userClaims.includes(mainModule) || userClaims.includes(subModule) || userClaims.includes(requiredClaim)
}



export const hasAnyRequiredClaim = (userClaims: string [] | undefined, requiredClaims: string[]): boolean => {
	if (!userClaims) {
		return false
	}

	for (let claim of requiredClaims) {
		if (hasRequiredClaim(userClaims, claim)) return true
	}
	// console.log(`User ${hasClaims ? 'has rights to visit' : 'has no rights to visit '} ${requiredClaims}`)
	return false
}